var map = {
	"./ColorPicker": 54377,
	"./ColorPicker.js": 54377,
	"./Dashboard": 15278,
	"./Dashboard copy": 31724,
	"./Dashboard copy.js": 31724,
	"./Dashboard.js": 15278,
	"./DashboardAdd": 44841,
	"./DashboardAdd copy": 18613,
	"./DashboardAdd copy.js": 18613,
	"./DashboardAdd.js": 44841,
	"./DashboardEdit": 91757,
	"./DashboardEdit copy": 84459,
	"./DashboardEdit copy 2": 86146,
	"./DashboardEdit copy 2.js": 86146,
	"./DashboardEdit copy.js": 84459,
	"./DashboardEdit.js": 91757,
	"./MobileConfig": 73106,
	"./MobileConfig.js": 73106,
	"./MobileConfigEdit": 9846,
	"./MobileConfigEdit.js": 9846,
	"./ParameterEdit": 63971,
	"./ParameterEdit.js": 63971,
	"./ParameterList": 37729,
	"./ParameterList.js": 37729,
	"./WidgetConfig": 41644,
	"./WidgetConfig.js": 41644,
	"./WidgetConfigEdit": 14829,
	"./WidgetConfigEdit.js": 14829,
	"./WidgetGroupList": 17452,
	"./WidgetGroupList.js": 17452,
	"./WidgetGroupListAdd": 26376,
	"./WidgetGroupListAdd.js": 26376,
	"./WidgetList": 51040,
	"./WidgetList.js": 51040,
	"./WidgetListAdd": 91483,
	"./WidgetListAdd.js": 91483,
	"./WidgetListEdit": 27823,
	"./WidgetListEdit.js": 27823,
	"./WidgetPositionConfig": 96303,
	"./WidgetPositionConfig copy": 54344,
	"./WidgetPositionConfig copy.js": 54344,
	"./WidgetPositionConfig.js": 96303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5900;